import styled from "styled-components";

export const ButtonRow = styled.div`
  display: flex;
  gap: 0.5rem;
`;
